module.exports = __webpack_public_path__ + "img/headset.1e34a9c9.jpg";